import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { AccountService } from '@app/core/services/account.service';
import { Observable, EMPTY } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { LoggerService } from '@app/core/services/logger.service';
import { ApiResult } from '@app/base/soco';
import { ConstantsService } from '../services';

declare var swal: any;
require('sweetalert');

@Injectable()
/* istanbul ignore next */
export class BuilderResolver implements Resolve<ApiResult<any>> {
    /* istanbul ignore next */
    constructor(private accountSvc: AccountService, private loggerSvc: LoggerService, public constantsSvc: ConstantsService) { }
    /* istanbul ignore next */
    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<ApiResult<any>> {
      return this.accountSvc.resolveBuilderAccountInfo().pipe(
        catchError(err => {
          this.loggerSvc.error('Could not resolve builder account info.', err, []);
         swal(this.constantsSvc.errorSwal1, this.constantsSvc.resolverSwal, this.constantsSvc.errorSwal);
          return EMPTY;
      }));
    }
}
